import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const initialState = { order: null, addressSet: null, customer: null, stacks: [] };
const OrderContext = createContext(initialState);

export const useOrderContext = () => useContext(OrderContext);

const OrderProvider = ({ children, value }) => (
  <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
);

OrderProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object,
};

OrderProvider.defaultProps = {
  value: initialState,
};

export default OrderProvider;
